export const inEnglandQuestion = 'In England?';
export const NHSLoginError = 'Something went wrong. Please try again.';

export const ACCESS_NHS = 'Free access through the NHS';
export const ACCESS_RESEARCH = 'I am part of a Research Study';
export const ACCESS_EMPLOYER = 'I work for Google';
